import React from 'react';
import { ProductTile } from '@/components/ProductTile';
import styles from './SearchResultsList.module.scss';
import type * as Types from '@/stores/productsApiTypes';

export interface ISearchResultsList {
  title?: string;
  products: Types.Product[];
}

export const SearchResultsList = ({ products }: ISearchResultsList) => {
  if (products) {
    return (
      <div className={styles.SearchResultsList}>
        {products.map((product: Types.Product) => (
          <ProductTile product={product} key={product.code} disableLink />
        ))}
      </div>
    );
  }
  return null;
};
